import {Component, OnDestroy, OnInit, input} from '@angular/core';
import {Price} from '../../price.model';

import * as fromApp from './../../../store/app.reducers';
import * as fromUser from '../../../user/store/user.reducers';
import * as fromPayment from './../../store/payment.reducers';
import * as PaymentActions from './../../store/payment.actions';
import * as TrialActions from '../../../profile/trial/store/trial.actions';

import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {Cookie} from '../../../helper/cookie';
import {User} from '../../../user/user.model';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-price-box',
    templateUrl: './price-box.component.html',
    styleUrls: ['./price-box.component.scss'],
    standalone: false
})
export class PriceBoxComponent implements OnInit, OnDestroy {

  readonly price = input<Price>();
  userState: Observable<fromUser.State>;
  paymentState: Observable<fromPayment.State>;
  userSubscription: Subscription;
  cookie: Cookie;
  user: User;
  loading: boolean;

  constructor(
    private store: Store<fromApp.AppState>,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.cookie = new Cookie();
  }

  ngOnInit() {
    this.userState = this.store.select('user');
    this.paymentState = this.store.select('payment');
    this.userSubscription = this.store.select('user').subscribe(
      (userState: fromUser.State) => {
        if (userState.user !== null) {
          this.user = userState.user;
        }
      }
    );

  }

  onSelectPayment(price: Price) {
    const periodic = +price.permissions['auditor.limit'].periodic;
    if (periodic) {
      this.store.dispatch(
        new PaymentActions.CreatePaymentSubscriptionStripe({
          id: price.id,
          params: {}
        })
      );
    } else {
      const url = ['/payment', 'detail', price.id];
      this.store.dispatch(
        new TrialActions.SetTrialStepParam({stepName: 'payment', paramName: 'url', value: url})
      );
      const version = +this.cookie.getCookie('auditor-version');

      if (this.user.username.indexOf('trial.auditor') >= 0 || this.user.type === -1) {
        if (version === 3) {
          this.router.navigate(['/user/register']);
        } else if (version === 5) {
          this.router.navigate(['/user/register']);
        } else {
          this.router.navigate(url);
        }
      } else {
        this.router.navigate(url);
      }
    }
    // this.modalService.dismissAll();

  }

  onPayment(id: number) {
    this.loading = true;
    this.store.dispatch(
      new PaymentActions.CreatePayment(id)
    );
    // this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    // this.modalService.dismissAll();
  }

}
